import { useSyncExternalStore } from 'react'

import {
  cancelarDownload,
  cancelarTodosOsDownloads,
  enfileirarDownload,
} from './fila'
import {
  adicionarItem,
  atualizarItem,
  inscrever,
  limparItens,
  obterItens,
  removerItem,
} from './store'
import type { ApiDaBandejaDeDownloads, ItemDeDownload } from './types'

export const bandejaDeDownloads: ApiDaBandejaDeDownloads = {
  enfileirar: enfileirarDownload,
  cancelar: id => {
    cancelarDownload(id)
    removerItem(id)
  },
  adicionar: adicionarItem,
  atualizar: atualizarItem,
  remover: removerItem,
  limpar: () => {
    cancelarTodosOsDownloads()
    limparItens()
  },
}

export { LIMITE_DE_DOWNLOADS_SIMULTANEOS } from './fila'

export function useBandejaDeDownloads(): ApiDaBandejaDeDownloads & {
  itens: ItemDeDownload[]
} {
  const itens = useSyncExternalStore(inscrever, obterItens)

  return { ...bandejaDeDownloads, itens }
}

export type {
  ApiDaBandejaDeDownloads,
  AtualizacaoDeItemDeDownload,
  ContextoDaTarefaDeDownload,
  ItemDeDownload,
  NovoItemDeDownload,
  ResultadoDaTarefaDeDownload,
  StatusDoDownload,
  TarefaDeDownload,
} from './types'
